// src/components/LoadingOverlay.js
import React from "react";
import Lottie from "lottie-react";
import loaderAnimation from "../assets/animations/loader.json";

const LoadingOverlay = () => {
  return (
    <div
      style={{
        position: "fixed", // Covers the whole screen
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.1)", // Semi-transparent black overlay
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999, // Ensures it's on top of other content
      }}
    >
      {/* Your Lottie loader */}
      <Lottie
        animationData={loaderAnimation}
        loop={true}
        className="w-20 h-20" // Your specified Tailwind classes for size
      />
    </div>
  );
};

export default LoadingOverlay;
